import { render, staticRenderFns } from "./StudentManagement.vue?vue&type=template&id=2d08c6c8&lang=pug"
import script from "./StudentManagement.vue?vue&type=script&lang=ts"
export * from "./StudentManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports